import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { CountryIcons } from "../../global_styles/styles";

export type CountryType = {
  img: string;
  alt: string;
  title: string;
};

const Country = ({
  selectedCountry,
  setSelectedCountry,
  countries,
}: {
  selectedCountry?: CountryType;
  setSelectedCountry?: Dispatch<SetStateAction<CountryType | undefined>>;
  countries: CountryType[] | [];
}) => {
  const [allCountries, setAllCountries] = useState<CountryType[]>(countries);
  useEffect(() => {
    setSelectedCountry?.(countries[0]);
    setAllCountries(countries);
  }, [countries, setSelectedCountry]);
  return (
    <CountryIcons>
      {allCountries.map((item, idx) => (
        <button
          className={selectedCountry?.title === item.title ? "active" : ""}
          key={idx}
          style={{
            padding: "4px",
            backgroundColor: "#88888846",
            borderRadius: "9px",
            // border: "1px solid gray",
          }}
          onClick={() => setSelectedCountry && setSelectedCountry(item)}
        >
          <img
            className={selectedCountry?.title === item.title ? "activeImg" : ""}
            src={item.img}
            alt={item.alt}
          />
        </button>
      ))}
    </CountryIcons>
  );
};

export default Country;
